var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:[_vm.$style.avatar, _vm.bordered ? _vm.$style.bordered : '', _vm.$style[("size" + _vm.size)] ],style:({borderColor: _vm.borderColor}),attrs:{"href":"javascript: void(0);"}},[_c('img',{attrs:{"src":_vm.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }